import { EnvName } from '@shared-core/features/env'

const PRODUCTION_BASE_URL = 'https://api.kartoy.app'

// Web: API URL задаётся при деплое через VITE_API_BASE_URL в entry.tsx.
export const API_BASE_URLS: Partial<Record<EnvName, string>> = {
  [EnvName.production]: PRODUCTION_BASE_URL,
}

export function getApiBaseUrl(env: EnvName): string {
  return API_BASE_URLS[env] ?? PRODUCTION_BASE_URL
}
